import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
export default function Footer() {
  return (
    <footer className="footer">
      <hr className="footer-line" />
      <p>&copy; {new Date().getFullYear()} Riverchain. All rights reserved.</p>
    </footer>
  );
}
